import Pikaday from 'pikaday';
import 'pikaday/css/pikaday.css';

(function () {
	const datePickers = [].slice.call(document.querySelectorAll('.js-datepicker'));

	datePickers.forEach(dp => {
		// eslint-disable-next-line
		new Pikaday({
			field: dp,
			minDate: dp.getAttribute('data-min') ? new Date(dp.getAttribute('data-min')) : new Date(),
			maxDate: dp.getAttribute('data-max') ? new Date(dp.getAttribute('data-max')) : undefined,
			format: 'D MMMM YYYY'
		});
	});
}());
